const tableMetadata = [
  {
    id: 'name',
    renderingField: 'name',
    width: '25%',
    numeric: false,
    disablePadding: false,
    label: 'Name',
    alignment: 'left',
  },
  {
    id: 'description',
    renderingField: 'description',
    width: '75%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Description',
    alignment: 'left',
  },
];

export default tableMetadata;
